export enum SIDE_TITLE {
  FIXED = 'Fixed',
  VARIABLE = 'Variable',
}

export enum VAULT_SIDE {
  FIXED = 0,
  VARIABLE = 1,
}
